import { QueryClient } from '@tanstack/react-query';
import { predicateType } from '@_shared/libs';

export function clearFolderListCache(queryClient: QueryClient) {
	queryClient.invalidateQueries({
		predicate: (query) => predicateType(query, 'folderList'),
	});
}
